import SparklesIcon from "@heroicons/react/24/solid/SparklesIcon";
import { styled as styling } from "@mui/material/styles";
import Link from "next/link";
import Color from "../../../assets/colors";

export const JobContainer = styling("div")({
  display: "grid",
  gridTemplateColumns: "repeat(3, 1fr)",
  gridTemplateRows: "repeat(1, 1fr)",
  gap: "1rem",
  width: "100%",

  "@media (max-width: 1280px)": {
    display: "flex",
    overflowX: "scroll",
  },

  "&::-webkit-scrollbar": {
    display: "none",
  },
});

export const PaginationContainer = styling("div")({
  display: "flex",
  justifyContent: "center",
  gap: "0.5rem",
  marginTop: "1rem",
});

export const PaginationButton = styling("div")({
  border: `1px solid ${Color.black}`,
  borderRadius: "25rem",
  width: "0.5rem",
  height: "0.5rem",

  transition: "all 0.15s ease-in-out",
});

export const JobCard = styling(Link)({
  borderRadius: "0.5rem",
  border: `1px solid ${Color.grey}`,
  minHeight: "7.4375rem",
  width: "100%",
  padding: "0.94rem 0.65rem 0.88rem 0.65rem",

  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",

  textDecoration: "none",

  transition: "box-shadow 0.1s ease-in-out, transform 0.1s ease-in-out",

  "@media (min-width: 1280px)": {
    "&:hover": {
      border: `1px solid ${Color.black}`,
      boxShadow: "4px 4px 0px rgba(0, 0, 0, 1)",
      transform: "translate(-4px, -4px)",
    },
  },

  "@media (max-width: 1280px)": {
    minWidth: "21rem",
  },

  "@media (max-width: 640px)": {
    minWidth: "18.25rem",
  },
});

export const OverlayContainer = styling("div")((props) => ({
  position: "absolute",
  height: "2.25rem",
  width: "10rem",
  ...(props.position === "right" && {
    right: 0,
  }),
  ...(props.position === "left" && {
    left: 0,
  }),
  top: 0,
  zIndex: "10",
  background:
    props.position === "right"
      ? "linear-gradient(to right, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 70%)"
      : "linear-gradient(to left, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 70%)",

  pointerEvents: "none",
}));

export const ButtonContainer = styling("div")((props) => ({
  position: "absolute",
  zIndex: "12",
  ...(props.position === "right" && {
    right: 0,
  }),
  ...(props.position === "left" && {
    left: 0,
  }),
  pointerEvents: "auto",
}));

export const FilterChip = styling("div")((props) => ({
  background: props.selected ? Color.black : Color.white,
  color: props.selected ? Color.white : "rgba(0, 0, 0, 0.60)",
  border: `1px solid ${props.selected ? "#2E2E2E" : Color.darkGrey}`,
  borderRadius: "32rem",

  fontSize: "0.875rem",
  whiteSpace: "nowrap",

  padding: "0.4065rem 1rem",

  transition: "all 0.15s ease-in-out",
  userSelect: "none",

  "@media (min-width: 1280px)": {
    ...(!props.selected
      ? {
          "&:hover": {
            background: Color.lightHiredlyPurple,
            color: Color.black,
            border: `1px solid ${Color.black}`,
            cursor: "pointer",
          },
        }
      : {
          "&:hover": {
            background: Color.black,
            cursor: "pointer",
          },
        }),
  },
}));

export const JobInfoChip = styling("div")({
  background: Color.backgroundGrey,
  color: "rgba(0, 0, 0, 0.60)",
  borderRadius: "0.25rem",

  fontSize: "0.625rem",
  fontWeight: "700",

  padding: "0.25rem 0.62rem",
});

export const HighlightChip = styling("div")({
  display: "flex",
  alignItems: "center",
  gap: "0.25rem",

  background: Color.lightHiredlyPurple,
  color: Color.darkPurple,
  border: `1px solid ${Color.darkPurple}`,
  borderRadius: "0.25rem",

  fontSize: "0.625rem",
  fontWeight: "400",
  letterSpacing: "0.09375rem",

  padding: "0.125rem 0.3rem",
});

export const SparklesIconStyled = styling(SparklesIcon)({
  width: "0.625rem",
  height: "0.625rem",
});
